import { useEffect } from "react";

/** Client-side redirect to an absolute or root-relative external URL. */
export function ExternalRedirect({ to }: { to: string }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return (
    <p data-testid="external-redirect">
      Redirecting to <a href={to}>{to}</a>…
    </p>
  );
}
